(function () {
  var GRID_SELECTOR = '#vcProductGrid';
  var NEUTRAL_BG = '#f4f2ee';

  var host = null;       // the height-animated wrapper that slides open
  var panel = null;      // .vc-qv inside it
  var openCard = null;   // the .grid-item currently being quick viewed
  var openRow = [];      // every card on that card's row
  var images = [];
  var imageIndex = 0;
  var noteTimer = null;
  var resizeTimer = null;

  /* ------------------------------------------------------------------
     Colour
     ------------------------------------------------------------------ */
  function parseHex(hex) {
    if (!hex) return null;
    var h = String(hex).replace('#', '').trim();
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    return [
      parseInt(h.slice(0, 2), 16),
      parseInt(h.slice(2, 4), 16),
      parseInt(h.slice(4, 6), 16)
    ];
  }

  // Relative luminance, so text on a dark paint goes white and text on a
  // pale paint stays the theme navy - the same contrast test the
  // colour-pairings block uses for its on-swatch names.
  function luminance(rgb) {
    var c = rgb.map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  function contrast(a, b) {
    var hi = Math.max(a, b), lo = Math.min(a, b);
    return (hi + 0.05) / (lo + 0.05);
  }

  var NAVY_LUM = luminance([0x46, 0x45, 0x57]);

  // Take whichever of the two inks actually reads better ON THIS PAINT,
  // rather than trusting a fixed lightness threshold.
  //
  // 8 Sep 2026: the old test was `luminance > 0.42`, well above the point
  // (about 0.30) where navy overtakes white - so every mid-tone paint was
  // given white text at 2.2-3:1. Measuring both ratios and keeping the
  // higher one moves 20 colours to navy (Penally Garden, Blue Sky, Sage
  // Against the Machine, Spiced Marmalade, Coralina, Etruscan Grey and the
  // rest of the mid-tones) and lifts the worst panel on the whole range
  // from 2.25:1 to 3.09:1. Nothing can get worse: the winner is by
  // definition at least as legible as whatever the threshold picked.
  //
  // `ink` is the inverse of `text` - the panel hands it to the solid Buy a
  // sample button, whose fill is currentColor.
  function schemeFor(hex) {
    var rgb = parseHex(hex);
    if (!rgb) return { text: '#464557', ink: '#ffffff' };
    var L = luminance(rgb);
    return contrast(L, 1) >= contrast(L, NAVY_LUM)
      ? { text: '#ffffff', ink: '#464557' }
      : { text: '#464557', ink: '#ffffff' };
  }

  /* ------------------------------------------------------------------
     Panel markup
     ------------------------------------------------------------------ */
  function buildPanel() {
    host = document.createElement('div');
    host.id = 'vcQuickViewHost';
    host.className = 'grid-item';

    panel = document.createElement('div');
    panel.className = 'vc-qv';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Quick view');
    panel.innerHTML =
      '<button type="button" class="vc-qv__close" aria-label="Close quick view">&times;</button>' +
      '<div class="vc-qv__inner">' +
        '<div class="vc-qv__media">' +
          '<div class="vc-qv__stage">' +
            '<img alt="">' +
            '<button type="button" class="vc-qv__nav vc-qv__nav--prev" aria-label="Previous photo">&lsaquo;</button>' +
            '<button type="button" class="vc-qv__nav vc-qv__nav--next" aria-label="Next photo">&rsaquo;</button>' +
          '</div>' +
          '<div class="vc-qv__thumbs"></div>' +
        '</div>' +
        '<div class="vc-qv__info">' +
          '<h2 class="vc-qv__title"></h2>' +
          '<p class="vc-qv__sub"></p>' +
          '<div class="vc-qv__rating"></div>' +
          '<div class="vc-qv__price"></div>' +
          '<div class="vc-qv__actions">' +
            '<a class="vc-qv__btn vc-qv__btn--ghost" href="#"><span>Find out more</span></a>' +
            '<button type="button" class="vc-qv__btn vc-qv__btn--solid vc-qv__sample"><span></span></button>' +
          '</div>' +
          '<p class="vc-qv__desc"></p>' +
          '<dl class="vc-qv__details"></dl>' +
          '<p class="vc-qv__note" role="status" aria-live="polite"></p>' +
        '</div>' +
      '</div>';

    host.appendChild(panel);
    wirePanel();
  }

  function q(sel) { return panel.querySelector(sel); }

  /* ------------------------------------------------------------------
     Reading a card
     ------------------------------------------------------------------ */
  function cardData(card) {
    if (card.__vcQv !== undefined) return card.__vcQv;
    var tag = card.querySelector('script.vc-qv-data');
    try {
      card.__vcQv = tag ? JSON.parse(tag.textContent) : null;
    } catch (e) {
      card.__vcQv = null;
    }
    return card.__vcQv;
  }

  // The panel background is ALWAYS a plain colour.
  //
  // 8 Sep 2026: it used to fall back to the product's flat colour tile
  // IMAGE whenever no hex was on file for the handle - but those tiles
  // carry the colour's name printed across them, so the panel showed
  // giant lettering behind its own text (Jam First, reported by Olly).
  // Worse, with no hex, schemeFor() fell through to its default navy
  // text, which on a dark paint like that one is close to unreadable.
  //
  // Every paint card now prints its own hex, straight from the product's
  // custom.colour_hex metafield (see snippets/product-grid-item.liquid),
  // so a newly added colour is right the moment it is created. The
  // window.vcPaintHex map stays as a fallback - it is a hand-maintained
  // list and had gone ten colours stale, which is what caused this - and
  // a colour with neither resolves to the neutral, still plain and still
  // legible because schemeFor('') pairs it with the navy text.
  function backgroundFor(data) {
    if (data.hex && parseHex(data.hex)) return { hex: data.hex };
    var mapped = (window.vcPaintHex && window.vcPaintHex[data.handle]) || '';
    if (mapped && parseHex(mapped)) return { hex: mapped };
    return { hex: '' };
  }

  function starsFor(rating) {
    var full = Math.floor(rating + 0.25);
    var out = '';
    for (var i = 1; i <= 5; i++) out += (i <= full ? '★' : '☆');
    return out;
  }

  /* ------------------------------------------------------------------
     Filling the panel
     ------------------------------------------------------------------ */
  function fill(card) {
    var data = cardData(card);
    if (!data) return false;

    var bg = backgroundFor(data);
    var scheme = schemeFor(bg.hex);

    panel.style.backgroundColor = bg.hex || NEUTRAL_BG;
    panel.style.backgroundImage = 'none';
    panel.style.color = scheme.text;
    panel.style.setProperty('--vc-qv-ink', scheme.ink);

    q('.vc-qv__title').textContent = data.title;

    var sub = q('.vc-qv__sub');
    sub.textContent = data.subtitle || '';
    sub.style.display = data.subtitle ? '' : 'none';

    var rating = Number(data.rating) || 0;
    var reviews = Number(data.reviews) || 0;
    var ratingEl = q('.vc-qv__rating');
    if (rating > 0 && reviews > 0) {
      ratingEl.innerHTML =
        '<span class="vc-qv__stars" aria-hidden="true">' + starsFor(rating) + '</span>' +
        '<span class="vc-qv__ratingCount">' + rating.toFixed(2) + ' out of 5 &middot; ' +
        reviews + (reviews === 1 ? ' review' : ' reviews') + '</span>';
      ratingEl.style.display = '';
    } else {
      ratingEl.innerHTML = '';
      ratingEl.style.display = 'none';
    }

    q('.vc-qv__price').innerHTML =
      data.price +
      (data.priceUnit ? '<span class="vc-qv__priceUnit">' + data.priceUnit + '</span>' : '');

    q('.vc-qv__btn--ghost').setAttribute('href', data.url);

    var sample = q('.vc-qv__sample');
    if (data.sampleId) {
      sample.style.display = '';
      sample.disabled = false;
      sample.setAttribute('data-variant', data.sampleId);
      sample.querySelector('span').textContent = 'Buy a sample ' + data.samplePrice;
    } else {
      sample.style.display = 'none';
    }

    var desc = q('.vc-qv__desc');
    desc.textContent = data.description || '';
    desc.style.display = data.description ? '' : 'none';

    var details = q('.vc-qv__details');
    var rows = '';
    if (data.sizes) rows += '<div><dt>Sizes:</dt><dd>' + data.sizes + '</dd></div>';
    if (data.finishes) rows += '<div><dt>Finishes:</dt><dd>' + data.finishes + '</dd></div>';
    details.innerHTML = rows;
    details.style.display = rows ? '' : 'none';

    q('.vc-qv__note').textContent = '';

    images = (data.images || []).map(function (src, i) {
      return { src: src, alt: (data.alts && data.alts[i]) || data.title };
    });
    imageIndex = 0;
    renderThumbs();
    showImage(0);
    return true;
  }

  function renderThumbs() {
    var wrap = q('.vc-qv__thumbs');
    wrap.innerHTML = '';
    if (images.length < 2) { wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    images.forEach(function (img, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vc-qv__thumb';
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + images.length);
      var thumb = new Image();
      // PERFORMANCE, 27 Aug 2026: these thumbnails render at 62x62 CSS px, but
      // img.src is the 1024x1024 CDN image (see the "images" array built in
      // snippets/product-grid-item.liquid, which pipes every image through
      // img_url: '1024x1024'). 160px still covers 62px at 2.5x DPR, so this is
      // visually identical. The stage image in showImage() is deliberately
      // left at 1024x1024 - that one is correct for retina.
      // String() preserves the old assignment's coercion exactly if src is ever
      // not a string, and .replace() simply no-ops if the token is absent.
      thumb.src = String(img.src).replace('_1024x1024', '_160x160');
      thumb.alt = '';
      thumb.loading = 'lazy';
      b.appendChild(thumb);
      b.addEventListener('click', function () { showImage(i); });
      wrap.appendChild(b);
    });
  }

  function showImage(i) {
    if (!images.length) return;
    imageIndex = Math.max(0, Math.min(i, images.length - 1));

    var img = q('.vc-qv__stage img');
    img.classList.remove('is-loaded');
    img.onload = function () { img.classList.add('is-loaded'); };
    img.src = images[imageIndex].src;
    img.alt = images[imageIndex].alt;
    if (img.complete) img.classList.add('is-loaded');

    var thumbs = panel.querySelectorAll('.vc-qv__thumb');
    for (var t = 0; t < thumbs.length; t++) {
      if (t === imageIndex) thumbs[t].classList.add('is-current');
      else thumbs[t].classList.remove('is-current');
    }

    var single = images.length < 2;
    var prev = q('.vc-qv__nav--prev');
    var next = q('.vc-qv__nav--next');
    prev.disabled = imageIndex === 0;
    next.disabled = imageIndex === images.length - 1;
    prev.style.display = single ? 'none' : '';
    next.style.display = single ? 'none' : '';
  }

  /* ------------------------------------------------------------------
     Opening and closing
     ------------------------------------------------------------------ */

  // Cards sharing a top edge are on the same row. Measured with the
  // panel detached, so the panel's own height can never change which
  // cards count as "this row".
  function isVisible(el) { return !!el.offsetParent || el.offsetWidth > 0; }

  function rowFor(card) {
    var grid = card.parentNode;
    var top = card.offsetTop;
    var out = [];
    for (var i = 0; i < grid.children.length; i++) {
      var el = grid.children[i];
      if (el === host || !el.classList.contains('grid-item')) continue;
      // A card the colour filter has hidden reports offsetTop 0, which
      // would otherwise drag every hidden card into the first row.
      if (!isVisible(el)) continue;
      if (Math.abs(el.offsetTop - top) < 4) out.push(el);
    }
    return out;
  }

  function detachHost() {
    if (host && host.parentNode) host.parentNode.removeChild(host);
  }

  function chipOf(card) { return card.querySelector('.vc-qv-btn'); }

  function open(card) {
    var grid = card.closest(GRID_SELECTOR);
    if (!grid) return;
    if (!host) buildPanel();

    // Swapping to another card on the row the panel is already under
    // should change the contents, not collapse and reopen.
    var inPlace = !!openCard && openRow.indexOf(card) !== -1;

    if (openCard) {
      openCard.classList.remove('vc-qv-active');
      var oldChip = chipOf(openCard);
      if (oldChip) oldChip.textContent = 'Quick view';
    }

    detachHost();

    openRow = rowFor(card);
    var last = openRow[openRow.length - 1];
    grid.insertBefore(host, last.nextSibling);

    if (!fill(card)) { detachHost(); openCard = null; return; }

    openCard = card;
    card.classList.add('vc-qv-active');
    var chip = chipOf(card);
    if (chip) chip.textContent = 'Viewing';

    if (inPlace) {
      setHeightInstantly('auto');
    } else {
      host.style.height = '0px';
      void host.offsetHeight;
      host.style.height = panel.offsetHeight + 'px';
      releaseHeightSoon();
      scrollPanelIntoView();
    }
  }

  // transitionend normally hands the height back to the panel. It does
  // not fire if the transition never runs - a background tab, or a
  // reduced-motion setting - so back it with a timer of its own, or the
  // panel would be stuck at the height it had when it opened.
  function releaseHeightSoon() {
    window.setTimeout(function () {
      if (openCard && host && host.style.height !== '0px') host.style.height = 'auto';
    }, 460);
  }

  function setHeightInstantly(value) {
    host.classList.add('vc-qv-instant');
    host.style.height = value === 'auto' ? 'auto' : value;
    void host.offsetHeight;
    host.classList.remove('vc-qv-instant');
  }

  function close() {
    if (!openCard || !host) return;
    var chip = chipOf(openCard);
    if (chip) chip.textContent = 'Quick view';
    openCard.classList.remove('vc-qv-active');
    openCard = null;
    openRow = [];

    host.style.height = host.offsetHeight + 'px';
    void host.offsetHeight;
    host.style.height = '0px';
    window.setTimeout(function () {
      if (!openCard) detachHost();
    }, 420);
  }

  function reset() {
    openCard = null;
    openRow = [];
    if (host) host.style.height = '0px';
    detachHost();
  }

  function scrollPanelIntoView() {
    window.setTimeout(function () {
      if (!host || !host.parentNode) return;
      var rect = host.getBoundingClientRect();
      var overhang = rect.bottom - window.innerHeight;
      if (overhang <= 0) return;
      var headroom = Math.max(0, rect.top - 90);
      var by = Math.min(overhang + 24, headroom);
      if (by > 4) window.scrollBy({ top: by, behavior: 'smooth' });
    }, 420);
  }

  /* ------------------------------------------------------------------
     Panel wiring
     ------------------------------------------------------------------ */
  function wirePanel() {
    q('.vc-qv__close').addEventListener('click', close);
    q('.vc-qv__nav--prev').addEventListener('click', function () { showImage(imageIndex - 1); });
    q('.vc-qv__nav--next').addEventListener('click', function () { showImage(imageIndex + 1); });
    q('.vc-qv__sample').addEventListener('click', addSample);

    // Once open, let the panel own its height again, so a late-loading
    // image or a wrapped line cannot end up clipped.
    host.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'height' || e.target !== host) return;
      if (openCard && host.style.height !== '0px') host.style.height = 'auto';
    });
  }

  function note(msg) {
    var el = q('.vc-qv__note');
    el.textContent = msg;
    window.clearTimeout(noteTimer);
    if (msg) noteTimer = window.setTimeout(function () { el.textContent = ''; }, 6000);
  }

  function addSample() {
    var btn = q('.vc-qv__sample');
    var label = btn.querySelector('span');
    var id = btn.getAttribute('data-variant');
    if (!id || btn.disabled) return;

    var original = label.textContent;
    btn.disabled = true;
    label.textContent = 'Adding…';

    postJSON('/cart/add.js', { id: Number(id), quantity: 1 })
      .then(function () { return getJSON('/cart.js'); })
      .then(function (cart) {
        label.textContent = 'Added ✓';
        updateCartCount(cart);
        note('Sample added to your basket.');
        window.setTimeout(function () {
          label.textContent = original;
          btn.disabled = false;
        }, 2400);
      })
      .catch(function () {
        label.textContent = 'Try again';
        btn.disabled = false;
        note('Sorry, that sample could not be added — please try the product page.');
        window.setTimeout(function () { label.textContent = original; }, 2800);
      });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // The header and mobile-bar cart badges. ajaxify keeps its updater
  // private (only ajaxifyShopify.init is exposed), so this does what
  // ajaxify itself does: write the number and take .hidden-count off.
  // Without that class change the badge stays invisible when the first
  // item in an empty basket is added from here.
  function updateCartCount(cart) {
    var els = document.querySelectorAll('.cart-count');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = cart.item_count;
      if (cart.item_count > 0) els[i].classList.remove('hidden-count');
      else els[i].classList.add('hidden-count');
    }
  }

  /* ------------------------------------------------------------------
     Card wiring - delegated, so it survives the colour sidebar
     rebuilding the whole grid (see collection-filter-js.liquid).
     ------------------------------------------------------------------ */
  function activate(e) {
    var chip = e.target.closest ? e.target.closest('.vc-qv-btn') : null;
    if (!chip || !chip.closest(GRID_SELECTOR)) return;

    // The chip sits inside the card's own <a>, so both have to be stopped.
    e.preventDefault();
    e.stopPropagation();

    var card = chip.closest('.grid-item');
    if (!card) return;
    if (card === openCard) close();
    else open(card);
  }

  document.addEventListener('click', activate);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openCard) { close(); return; }

    var onChip = e.target.classList && e.target.classList.contains('vc-qv-btn');
    if (onChip && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar')) {
      activate(e);
      return;
    }

    if (!openCard) return;
    if (e.key === 'ArrowLeft') showImage(imageIndex - 1);
    if (e.key === 'ArrowRight') showImage(imageIndex + 1);
  });

  // A resize can change how many cards fit on a row, which would strand
  // the panel under the wrong one. Reopening against the same card puts
  // it back where it belongs.
  window.addEventListener('resize', function () {
    if (!openCard) return;
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var card = openCard;
      if (!card.parentNode || !document.contains(card)) { reset(); return; }
      setHeightInstantly('auto');
      openCard = null;
      openRow = [];
      open(card);
      setHeightInstantly('auto');
    }, 180);
  });

  // The colour sidebar re-renders #vcProductGrid in place when a filter
  // changes, which throws away both the open card and the panel.
  function watchGrid() {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid || !grid.parentNode || !window.MutationObserver) return;
    // Watch the column rather than the grid itself, so this keeps
    // working whether the filter rewrites the grid's contents or
    // replaces the whole #vcProductGrid element.
    new MutationObserver(function () {
      if (openCard && !document.contains(openCard)) reset();
    }).observe(grid.parentNode, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGrid);
  } else {
    watchGrid();
  }
})();
